import React from 'react'
import { withRouter } from 'react-router-dom'

import { Calendar } from 'primereact/calendar'
import { Toast } from 'primereact/toast'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { AuthContext } from '../../main/ProvedorAutenticacao'

import NavBar from '../../componentes/Navbar'

import PublicacoesService from '../../app/service/PublicacoesService'

class Publicacoes extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openSpinner: false,
      publicacoes: [],
      consultaDataInicial: '',
      consultaDataFinal: '',
      consultaPessoa: '',
      consultaAdvogado: '',
      consultaProcesso: '',
    }

    this.publicacoesService = new PublicacoesService();

    this.destinatarios = this.destinatarios.bind(this);
    this.advogados = this.advogados.bind(this);
  }

  consultarPublicacoes = async () => {
    var dataInicial = '';
    var dataFinal = '';
    if(this.state.consultaDataInicial != '' && this.state.consultaDataFinal != '') {
      dataInicial = this.formatarData(this.state.consultaDataInicial);
      dataFinal = this.formatarData(this.state.consultaDataFinal);
    }

    const filtro = {
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      pessoa: this.state.consultaPessoa,
      advogado: this.state.consultaAdvogado,
      numeroProcesso: this.state.consultaProcesso
    }

    this.setState({openSpinner: true});
    await this.publicacoesService.consultarPublicacoes(filtro)
      .then(response => {
        this.setState({publicacoes: response.data});
        console.log('Publicações ', response.data);
        this.setState({openSpinner: false});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${error}`, life: 4000});
      })
  }

  formatarData = (data) => {
    const ano = data.getFullYear();
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const dia = String(data.getDate()).padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
  };

  consultarInicial = async () => {
    const hoje = new Date();
    const dataFormatada = hoje.toISOString().split('T')[0];
    const filtro = {
      dataInicial: dataFormatada,
      dataFinal: dataFormatada,
      pessoa: "",
      advogado: "",
      numeroProcesso: ""
    }

    this.setState({openSpinner: true});
    await this.publicacoesService.consultarPublicacoes(filtro)
      .then(response => {
        this.setState({publicacoes: response.data});
        console.log('Publicações ', response.data);
        this.setState({openSpinner: false});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${error}`, life: 4000});
      })
  }

  destinatarios(rowData) {
    return(
      <React.Fragment>
        <Button icon="far fa-user" className="p-button-rounded p-button-text"
                tooltip="Incluir no Histórico"
                onClick={() => this.confirmaIncluirHistorico(rowData)}
                disabled={rowData.temHistorico == 'S' ? false : true}
                tooltipOptions={{position: 'top'}} />
      </React.Fragment>
    );
  }

  advogados(rowData) {
    return(
      <React.Fragment>
        <Button icon="fa fa-user-tie" className="p-button-rounded p-button-text"
                tooltip="Incluir no Histórico"
                onClick={() => this.confirmaIncluirHistorico(rowData)}
                disabled={rowData.temHistorico == 'S' ? false : true}
                tooltipOptions={{position: 'top'}} />
      </React.Fragment>
    );
  }

  async componentDidMount() {
    this.consultarInicial();
  }

  render() {
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-primary card-outline">
                    <div className="card-header">
                      <h3 className="card-title">
                        <i className="fa fa-clipboard-list"></i>
                        <span> Publicações</span>
                      </h3>  
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-1">
                          <div className="form-group">
                            <Calendar id="idConsultaPorDataInicial" 
                                      value={this.state.consultaDataInicial} 
                                      onChange={(e) => this.setState({ consultaDataInicial: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      placeholder="Dt Inicial"
                                      mask="99/99/9999"/>
                          </div>
                        </div>
                        <div className="col-md-1">
                          <div className="form-group">
                            <Calendar id="idConsultaPorDataFinal" 
                                      value={this.state.consultaDataFinal} 
                                      onChange={(e) => this.setState({ consultaDataFinal: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      placeholder="Dt Final"
                                      mask="99/99/9999"/>
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <InputText id="consultaProcesso" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.consultaProcesso}
                                      onChange={e => this.setState({consultaProcesso: e.target.value})}
                                      placeholder="Número do Processo"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <InputText id="consultaPessoa" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.consultaPessoa}
                                      onChange={e => this.setState({consultaPessoa: e.target.value})}
                                      placeholder="Pessoa"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <InputText id="consultarAdvogado" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.consultaAdvogado}
                                      onChange={e => this.setState({consultaAdvogado: e.target.value})}
                                      placeholder="Advogado"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-md-1">
                          <div className="form-group">
                            <Button style={{height: '32px'}} type="button" className="p-button-info p-button-sm" 
                                  onClick={this.consultarPublicacoes}>
                              <i className="fas fa-search"></i>&nbsp;&nbsp;Consultar</Button>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <DataTable value={this.state.publicacoes}
                              emptyMessage="Nenhuma Movimentação">
                              <Column field="dataPublicacao" header="Data"></Column> 
                              <Column field="tribunal" header="Tribunal"></Column>
                              <Column field="processo.nrCnj" header="Processo"></Column>
                              <Column field="pulicacao" header="Publicação"></Column>
                              <Column field="usuariosDestinatarios" header="Destinatários"></Column>
                              <Column field="advogados" header="Advogados"></Column>
                              <Column field="link" header="Link"></Column>
                            </DataTable>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    );
  }
}

Publicacoes.contextType = AuthContext;
export default withRouter (Publicacoes)

